var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ecommerce"}},[(_vm.isSelectedBot)?_c('div',[_c('v-tabs',{attrs:{"slider-color":_vm.$vuetify.theme.primary,"color":"white"},model:{value:(_vm.currentView),callback:function ($$v) {_vm.currentView=$$v},expression:"currentView"}},[(_vm.role === 'nvbb_driver' && _vm.selectedBot.theme == 'nvbb')?[_c('v-tab',{attrs:{"href":"#nvbb-lalamove","ripple":""}},[_vm._v(_vm._s(_vm.$t('Lalamove')))])]:[(
            (_vm.selectedBot.theme != 'lookchingiant' ||
              [].concat( _vm.$store.state.lamyPage ).includes(_vm.selectedBot.pageid)) &&
            !(_vm.selectedBot.theme === 'seagull' && _vm.$store.state.privilege.role === 'warehouse')
          )?_c('v-tab',{attrs:{"href":"#Products","ripple":""}},[_vm._v(_vm._s(_vm.$t('Products'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.$store.state.nestlePages.some(function (page) { return page.pageid == _vm.selectedBot.pageid; }))?_c('v-tab',{attrs:{"href":"#Bundles","ripple":""}},[_vm._v("\n          "+_vm._s(_vm.$t('Bundles'))+"\n        ")]):_vm._e(),_vm._v(" "),(
            _vm.showProductAnalytic &&
            ((!['scgdistribution'].includes(_vm.selectedBot.theme) &&
              !['thailandpostmart'].includes(_vm.selectedBot.type)) ||
              [
                '100684322285177',
                '109154847972476',
                '182366355126026',
                '490162721055346',
                '178737485661189',
                '608979672643642',
                '100378482209868',
                '769473233454900'
              ].includes(_vm.selectedBot.pageid)) &&
            !(_vm.selectedBot.theme === 'seagull' && _vm.$store.state.privilege.role === 'warehouse')
          )?_c('v-tab',{attrs:{"href":"#ProductAnalytics","ripple":""}},[_vm._v(_vm._s(_vm.$t('Sales Report'))+"\n        ")]):_vm._e(),_vm._v(" "),(
            (!['nvbb', 'runkan', 'lookchingiant', 'tcp'].includes(_vm.selectedBot.theme) &&
              !['thailandpostmart'].includes(_vm.selectedBot.type) &&
              !(
                _vm.selectedBot.theme === 'seagull' && _vm.$store.state.privilege.role === 'warehouse'
              )) ||
            ['182366355126026'].includes(_vm.selectedBot.pageid)
          )?_c('v-tab',{attrs:{"href":"#cartsummary","ripple":""}},[_vm._v(_vm._s(_vm.$t('Cart Summary'))+"\n        ")]):_vm._e(),_vm._v(" "),(
            [
              '109154847972476',
              '108496771338010',
              '100378482209868',
              '107060654853653',
              '109181747969457',
              '103800371873416',
              '108308318379330',
              '101127682506041',
              '100274418904517',
              '108556638438120',
              '108026141827592',
              '490162721055346',
              '115739694445355',
              '100396882225293',
              '178737485661189',
              '608979672643642',
              '769473233454900'
            ].includes(_vm.selectedBot.pageid)
          )?_c('v-tab',{attrs:{"href":"#cartreport","ripple":""}},[_vm._v(_vm._s(_vm.$t('Cart Summary History'))+"\n        ")]):_vm._e(),_vm._v(" "),(
            (!['scgdistribution'].includes(_vm.selectedBot.theme) &&
              !['thailandpostmart'].includes(_vm.selectedBot.type)) ||
            [
              '100684322285177',
              '109154847972476',
              '182366355126026',
              '490162721055346',
              '178737485661189',
              '608979672643642',
              '100378482209868',
              '769473233454900'
            ].includes(_vm.selectedBot.pageid)
          )?_c('v-tab',{attrs:{"href":"#ecommerce-order-summary","ripple":""}},[_vm._v(_vm._s(_vm.selectedBot.theme == 'nvbb' ? _vm.$t('Cart Summary') : _vm.$t('Order Summary'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.selectedBot.theme == 'nvbb')?[_c('v-tab',{attrs:{"href":"#nvbb-order-summary","ripple":""}},[_vm._v(_vm._s(_vm.$t('Pre-order Summary')))]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#nvbb-lalamove","ripple":""}},[_vm._v(_vm._s(_vm.$t('Lalamove')))])]:_vm._e(),_vm._v(" "),(_vm.$aston.astonpages.includes(_vm.selectedBot.pageid))?_c('v-tab',{attrs:{"href":"#aston-ads","ripple":""}},[_vm._v(_vm._s(_vm.$t('Aston'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.$aston.astonpages.includes(_vm.selectedBot.pageid))?_c('v-tab',{attrs:{"href":"#AstonAuction","ripple":""}},[_vm._v(_vm._s(_vm.$t('Auction'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.selectedBot.pageid == '853384435005817')?[_c('v-tab',{attrs:{"href":"#BearhouseOrder","ripple":""}},[_vm._v(_vm._s(_vm.$t('Order Summary'))+" 2")])]:_vm._e(),_vm._v(" "),(
            !['thailandpostmart'].includes(_vm.selectedBot.type) &&
            !['tcp'].includes(_vm.selectedBot.theme) &&
            !(_vm.selectedBot.theme === 'seagull' && _vm.$store.state.privilege.role === 'warehouse')
          )?[_c('v-tab',{attrs:{"href":"#Promotion","ripple":""}},[_vm._v(_vm._s(_vm.$t('Coupon')))])]:_vm._e(),_vm._v(" "),(['cityfresh'].includes(_vm.selectedBot.theme))?_c('v-tab',{attrs:{"href":"#CouponReport","ripple":""}},[_vm._v(_vm._s(_vm.$t('coupon_report'))+"\n        ")]):_vm._e(),_vm._v(" "),(
            (!['lookchingiant', 'scgdistribution', 'tcp'].includes(_vm.selectedBot.theme) &&
              !['thailandpostmart'].includes(_vm.selectedBot.type) &&
              !(
                _vm.selectedBot.theme === 'seagull' && _vm.$store.state.privilege.role === 'warehouse'
              )) ||
            [
              '100684322285177',
              '109154847972476',
              '182366355126026',
              '490162721055346',
              '178737485661189',
              '608979672643642',
              '100378482209868',
              '769473233454900'
            ].includes(_vm.selectedBot.pageid)
          )?_c('v-tab',{attrs:{"href":"#Payment","ripple":""}},[_vm._v(_vm._s(_vm.$t('Payments'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.selectedBot.theme == 'nvbb')?[_c('v-tab',{attrs:{"href":"#NvbbSummaryDrink","ripple":""}},[_vm._v("\n            "+_vm._s(_vm.$t('สรุปยอดผลิต'))+"\n          ")])]:_vm._e(),_vm._v(" "),(
            (!['scgdistribution', 'tcp'].includes(_vm.selectedBot.theme) &&
              !['thailandpostmart'].includes(_vm.selectedBot.type) &&
              !(
                _vm.selectedBot.theme === 'seagull' && _vm.$store.state.privilege.role === 'warehouse'
              )) ||
            [
              '100684322285177',
              '109154847972476',
              '490162721055346',
              '178737485661189',
              '608979672643642',
              '100378482209868',
              '769473233454900'
            ].includes(_vm.selectedBot.pageid)
          )?_c('v-tab',{attrs:{"href":"#ShippingMethod","ripple":""}},[_vm._v(_vm._s(_vm.$t('Shipping Method'))+"\n        ")]):_vm._e(),_vm._v(" "),(['103876431747147', '176922345693076'].includes(_vm.selectedBot.pageid))?_c('v-tab',{attrs:{"href":"#Influencers","ripple":""}},[_vm._v(_vm._s(_vm.$t('Influencers'))+"\n        ")]):_vm._e(),_vm._v(" "),(['tcp'].includes(_vm.selectedBot.theme))?_c('v-tab',{attrs:{"href":"#OrderStatistics","ripple":""}},[_vm._v(_vm._s(_vm.$t('order_statistics'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isTremendous)?_c('v-tab',{attrs:{"href":"#setting","ripple":""}},[_vm._v(_vm._s(_vm.$t('Setting')))]):_vm._e()]],2),_vm._v(" "),(_vm.currentView == 'Products')?_c('div',[_c(_vm.$store.state.subcategory.includes(_vm.selectedBot.pageid) ? 'KanomProducts' : 'Products',{tag:"component"})],1):(_vm.currentView == 'ecommerce-order-summary')?_c('div',[_c('ecommerce-order-summary',{tag:"component"})],1):(_vm.currentView == 'nvbb-order-summary')?_c('div',[_c('nvbb-order-summary',{tag:"component"})],1):(_vm.currentView == 'nvbb-lalamove')?_c('div',[_c('nvbb-lalamove',{tag:"component"})],1):(_vm.currentView == 'aston-ads')?_c('div',[_c('aston-ads')],1):(_vm.currentView == 'aston-auction')?_c('div',[_c('aston-auction')],1):(_vm.currentView == 'Wholesale')?_c('div',[_c('wholesale')],1):(_vm.currentView == 'Payment')?_c('div',[_c('payment')],1):(_vm.currentView == 'BearhouseOrder')?_c('div',[_c('bearhouse-order')],1):(_vm.currentView == 'bearhouse-order2')?_c('div',[_c('bearhouse-order2')],1):(_vm.currentView == 'ProductAnalytics')?_c('div',[(_vm.showProductAnalytic)?_c('product-analytics'):_vm._e()],1):(_vm.currentView == 'cartsummary')?_c('div',[(_vm.selectedBot.theme == 'scgdistribution')?_c('cart-summary-scgdistribute'):_c('cart-summary')],1):(_vm.currentView == 'cartreport')?_c('div',[(
          [
            '109154847972476',
            '108496771338010',
            '100378482209868',
            '107060654853653',
            '109181747969457',
            '103800371873416',
            '108308318379330',
            '101127682506041',
            '100274418904517',
            '108556638438120',
            '108026141827592',
            '490162721055346',
            '115739694445355',
            '100396882225293',
            '178737485661189',
            '608979672643642',
            '769473233454900'
          ].includes(_vm.selectedBot.pageid)
        )?_c('cart-report-scgdistribute'):_vm._e()],1):(_vm.currentView == 'ShippingMethod')?_c('div',[_c('shipping-method')],1):(_vm.currentView == 'OrderStatistics')?_c('div',[_c('OrderStatistics')],1):(_vm.currentView == 'setting')?_c('div',[_c('EcommerceSetting')],1):_c('div',[_c(_vm.currentView,{tag:"component"})],1)],1):_c('div',[_c('template-empty')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22a46f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/ecommerce/ecommerce.vue
// module id = null
// module chunks = 